/* Product-page size chart (D17): move the highlight to the size just picked.
   The theme usually re-renders the picker from the server (which marks the right row);
   this keeps the drawer right in the moment before that, and when it doesn't. */
(function () {
  if (window.seSizeGuide) return;
  window.seSizeGuide = true;
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[type=radio][data-option-value], select[name^="options["]')) return;
    var picker = input.closest('variant-picker');
    var guide = picker && picker.querySelector('[data-size-guide]');
    if (!guide || !input.closest('fieldset, .product-form__input').querySelector('[data-size-guide]')) return;
    var value = input.value;
    guide.querySelectorAll('tbody tr[data-size]').forEach(function (tr) {
      tr.classList.toggle('is-picked', tr.getAttribute('data-size') === value);
    });
    guide.querySelectorAll('[data-sg-picked-line]').forEach(function (line) {
      var found = !!line.parentNode.querySelector('tr[data-size].is-picked');
      line.hidden = !found;
      var out = line.querySelector('[data-sg-picked]');
      if (out) out.textContent = value;
    });
  });
})();
